import { pdf } from "@react-pdf/renderer";
import Bill from "./Bill";
import toast from "react-hot-toast";
import { uploadToS3 } from "../../../Services/uploadToS3";
import { IProduct } from "../../../models/productData.model";
import { CompanyInfo } from "../../../models/quotationData.model";
import { OrderConfirmationPDF } from "../../../pages/EpcQuotation/OrderConfirmationPDF";
import { CustomerOrder, OrderItem } from "../../../models/Order.model";
import { calculateOrderTotals } from "../../../utils/orderTotals";

export const sendToWhatsapp = async (
  bookedProducts: IProduct[],
  companyInfo: CompanyInfo,
  transportPrice: number,
  discountPrice: number,
  type: string
): Promise<any> => {
  if (bookedProducts.length === 0) {
    toast.error("Please Add Goods");
    return;
  }

  let loadingToastId: string | null = null;
  try {
    loadingToastId = toast.loading("Generating invoice...");
    document.body.style.cursor = "wait";
    const productsWithGST = bookedProducts.map((product) => ({
      ...product,
      totalGST: product.gst,
    }));

    const totalGST = productsWithGST.reduce(
      (sum, product) => sum + product.totalGST,
      0
    );

    const billDocument = () => {
      switch (type) {
        case "quotation":
          return (
            <Bill
              trasnportPrice={transportPrice}
              discountPrice={discountPrice}
              bookedProducts={bookedProducts}
              companyInfo={companyInfo}
            />
          );
        case "pi":
          const orderItems: OrderItem[] = bookedProducts.map((item) => ({
            productName: item.productName,
            price: item.price ?? 0,
            quantity: item.quantity,
            transportPrice: transportPrice,
            discountPrice: item.discount || 0,
          }));

          const customerOrders: CustomerOrder[] = bookedProducts.map(
            (item) => ({
              _id: item._id,
              productName: item.productName,
              hsn: item.hsn ?? 0,
              price: item.price ?? 0,
              gst: item.gst ?? 0,
              productId: item,
              quantity: item.quantity,
              transportPrice: transportPrice,
              discountPrice: item.discount || 0,
            })
          );

          const grandTotalForPdf = calculateOrderTotals(
            orderItems,
            customerOrders
          ).grandTotal;

          return (
            <OrderConfirmationPDF
              orderItems={orderItems}
              customerInfo={companyInfo}
              customerOrders={customerOrders.map((order) => ({
                ...order,
                productId:
                  typeof order.productId === "string"
                    ? ({} as IProduct)
                    : order.productId,
              }))}
              grandTotal={grandTotalForPdf}
              transportPrice={transportPrice}
              discountPrice={discountPrice}
            />
          );
        default:
          return null;
      }
    };

    const doc = billDocument();
    if (!doc) throw new Error("Invalid document type");

    const pdfBlob = await pdf(doc).toBlob();

    // Convert Blob to Base64
    const base64String = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(pdfBlob);
      reader.onloadend = () => {
        if (typeof reader.result === "string") {
          resolve(reader.result.split(",")[1]); // Extract Base64 string
        } else {
          reject("Failed to convert PDF to Base64");
        }
      };
      reader.onerror = (error) => reject(error);
    });

    // Upload to S3
    const response = await uploadToS3(
      companyInfo.mobileNumber,
      base64String,
      "invoice.pdf"
    );
    if (response && response.success) {
      toast.success("Quotation Sent Successfully!");
    } else {
      toast.error("Error uploading invoice! Invalid response.");
    }

    return response;
  } catch (error) {
    console.error("Error generating PDF:", error);
    toast.error("Error generating invoice!");
  } finally {
    document.body.style.cursor = "default";
    if (loadingToastId) toast.dismiss(loadingToastId);
  }
};
